import { graphql } from "gatsby";
import React from "react";

const ContentParagraph = ({ content }) => (
  <div
    dangerouslySetInnerHTML={{
      __html: content.content.processed,
    }}
  />
);

export const query = graphql`
  fragment ParagraphContent on paragraph__content {
    type: __typename
    content: field_content {
      processed
    }
  }
`;

export default ContentParagraph;
